module.exports = __webpack_public_path__ + "img/toe_strike_chart.96b513ec.png";